'use es6';

import { applyDiff } from 'editor-iframe-lib/redux/utils/iframeStateSync';
import { SYNC_INAPP_STATE } from 'ContentEditorUI/redux/actions/actionTypes';
import PerformanceStatsGatherer from 'ContentEditorUI/lib/PerformanceStatsGatherer';
import SyncConfigManager from 'ContentEditorUI/redux/inpageSync/SyncConfigManager';
const appStateReducer = (state = {}, {
  type,
  diff,
  timeToCalculateDiff,
  _message
}) => {
  switch (type) {
    case SYNC_INAPP_STATE:
      {
        const applyStart = PerformanceStatsGatherer.now();
        const result = applyDiff(diff, state, {
          config: SyncConfigManager.getConfig()
        });
        if (PerformanceStatsGatherer.isGatheringStats()) {
          const applyDelta = PerformanceStatsGatherer.now() - applyStart;
          if (_message) {
            PerformanceStatsGatherer.getSingletonInstance().incrementCounterAndMeasure('inpageSync message latency', Date.now() - _message._start);
          }
          if (timeToCalculateDiff != null) {
            PerformanceStatsGatherer.getSingletonInstance().incrementCounterAndMeasure('inpageSync calculateDiff', timeToCalculateDiff);
          }
          PerformanceStatsGatherer.getSingletonInstance().incrementCounterAndMeasure('inpageSync applyDiff', applyDelta);
        }
        return result;
      }
    default:
      return state;
  }
};
export default appStateReducer;